import { useEffect, useState } from "react";
import confetti from "canvas-confetti";
import type { Fx } from "@shared/types";
import { subscribeFx } from "./fxBus";

function burst() {
  confetti({ particleCount: 140, spread: 75, origin: { y: 0.6 }, startVelocity: 45 });
}

/** A longer celebration for the end of the game. */
function finale() {
  const end = Date.now() + 2200;
  (function frame() {
    confetti({ particleCount: 6, angle: 60, spread: 60, origin: { x: 0 } });
    confetti({ particleCount: 6, angle: 120, spread: 60, origin: { x: 1 } });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

export interface Toast {
  name: string;
  points: number;
  key: number;
}

/**
 * Play confetti for celebration events and surface the latest "correct" toast.
 * Honours the OS reduced-motion setting — confetti is decoration, not signal.
 */
export function useFx(): Toast | null {
  const [toast, setToast] = useState<Toast | null>(null);

  useEffect(() => {
    const reduceMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    let timer: ReturnType<typeof setTimeout>;
    const unsubscribe = subscribeFx((fx: Fx) => {
      if (fx.type === "correct") {
        if (!reduceMotion) burst();
        const key = Date.now();
        setToast({ name: fx.name, points: fx.points, key });
        clearTimeout(timer);
        timer = setTimeout(() => setToast((t) => (t?.key === key ? null : t)), 2600);
      } else if (fx.type === "final") {
        if (!reduceMotion) finale();
      }
    });

    return () => {
      clearTimeout(timer);
      unsubscribe();
    };
  }, []);

  return toast;
}
